export default "__VITE_ASSET__BWUIaqC___"